import {
  GET_MAYBANK_APPOINTMENTS_SUCCESS,
  GET_MAYBANK_APPOINTMENTS_FAIL,
  GET_MAYBANK_APPOINTMENTS_DETAILS_SUCCESS,
  GET_MAYBANK_APPOINTMENTS_DETAILS_FAIL,
  ADD_MAYBANK_APPOINTMENTS_SUCCESS,
  ADD_MAYBANK_APPOINTMENTS_FAIL,
  UPDATE_MAYBANK_APPOINTMENTS_SUCCESS,
  UPDATE_MAYBANK_APPOINTMENTS_FAIL,
  DELETE_MAYBANK_APPOINTMENTS_SUCCESS,
  DELETE_MAYBANK_APPOINTMENTS_FAIL,
  CONFIRM_MAYBANK_APPOINTMENTS_SUCCESS,
  CONFIRM_MAYBANK_APPOINTMENTS_FAIL, 
  ADD_REMARKS_PRE_APPOINTMENTS_SUCCESS,
  ADD_REMARKS_PRE_APPOINTMENTS_FAIL,
  RESET_MAYBANK_APPOINTMENTS_STATE,
} from "./actionTypes"

const INIT_STATE = {
  appointmentsMaybank: [],
  appointmentsMaybankDetails: [],
  addMaybankAppointments: [],
  editMaybankAppointments: [],
  delMaybankAppointments: [],
  confirmMaybankAppointments: [],
  addRemarksPreAppointment: [],
}

const MaybankAppointments = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_MAYBANK_APPOINTMENTS_SUCCESS:
      return {
        ...state,
        appointmentsMaybank: action.payload,
      }

    case GET_MAYBANK_APPOINTMENTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_MAYBANK_APPOINTMENTS_DETAILS_SUCCESS:
      return {
        ...state,
        appointmentsMaybankDetails: action.payload,
      }

    case GET_MAYBANK_APPOINTMENTS_DETAILS_FAIL:
      return {
        ...state,
        error: action.payload,
        appointmentsMaybankDetails: action.payload,
      }

    case ADD_MAYBANK_APPOINTMENTS_SUCCESS:
      return {
        ...state,
        appointmentsMaybank: action.payload.data,
        addMaybankAppointments: action.payload,
      }

    case ADD_MAYBANK_APPOINTMENTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_MAYBANK_APPOINTMENTS_SUCCESS:
      return {
        ...state,
        editMaybankAppointments: action.payload,
      }

    case UPDATE_MAYBANK_APPOINTMENTS_FAIL:
      return {
        ...state,
        error: action.payload,
        editMaybankAppointments: action.payload,
      }
    case DELETE_MAYBANK_APPOINTMENTS_SUCCESS:
      return {
        ...state,
        delMaybankAppointments: action.payload,
      }

    case DELETE_MAYBANK_APPOINTMENTS_FAIL:
      return {
        ...state,
        error: action.payload,
        delMaybankAppointments: action.payload,
      }

    case CONFIRM_MAYBANK_APPOINTMENTS_SUCCESS:
      return {
        ...state,
        confirmMaybankAppointments: action.payload,
      }

    case CONFIRM_MAYBANK_APPOINTMENTS_FAIL:
      return {
        ...state,
        error: action.payload,
        confirmMaybankAppointments: action.payload,
      }
    case ADD_REMARKS_PRE_APPOINTMENTS_SUCCESS:
      return {
        ...state,
        addRemarksPreAppointment: action.payload,
      }

    case ADD_REMARKS_PRE_APPOINTMENTS_FAIL:
      return {
        ...state,
        error: action.payload,
        addRemarksPreAppointment: action.payload,
      }
    case RESET_MAYBANK_APPOINTMENTS_STATE:
      return {
        ...state,
        addMaybankAppointments: [],
        editMaybankAppointments: [],
        delMaybankAppointments: [],
        confirmMaybankAppointments: [],
        addRemarksPreAppointment: [],
        appointmentsMaybankDetails: [],
        error: [],
      }
    default:
      return state
  }
}

export default MaybankAppointments
